import { render, staticRenderFns } from "./KnifeHistoryModal.vue?vue&type=template&id=3c3fbf88&scoped=true"
import script from "./KnifeHistoryModal.vue?vue&type=script&lang=js"
export * from "./KnifeHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3fbf88",
  null
  
)

export default component.exports